import { render, staticRenderFns } from "./orderBreakdownWidget.vue?vue&type=template&id=7cd2a07a&"
import script from "./orderBreakdownWidget.vue?vue&type=script&lang=js&"
export * from "./orderBreakdownWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports